var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GenericButton',{staticClass:"c-button",class:_vm.classes,attrs:{"disabled":_vm.disabled,"href":_vm.href},on:{"click":_vm.onClick}},[(_vm.icon)?_c('Icon',{attrs:{"icon":_vm.icon,"title":_vm.iconTitle,"class-name":"icon"}}):_vm._e(),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }